<header class="admin-header">
  <div class="admin-header-container">
    <div class="admin-header-left">
      <a [routerLink]="['/']" class="admin-logo" title="Go to Home">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        <span>MarketPro</span>
      </a>
      <div class="admin-breadcrumb">
        <span class="breadcrumb-item">Admin</span>
      </div>
    </div>

    <div class="admin-header-right">
      <div class="admin-user-menu" *ngIf="isLoggedIn">
        <div class="admin-user-info">
          <div class="admin-user-avatar">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <span class="admin-user-name">{{ user?.firstName || user?.email || 'Admin' }}</span>
        </div>
        <button class="admin-logout-btn" (click)="logout()" title="Logout">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
            <polyline points="16 17 21 12 16 7"></polyline>
            <line x1="21" y1="12" x2="9" y2="12"></line>
          </svg>
        </button>
      </div>
      <a *ngIf="!isLoggedIn" [routerLink]="['/admin-login']" class="admin-login-link">
        Login
      </a>
    </div>
  </div>
</header>

